[<template>
  <div>
    <el-table
      :data="directories"
      class="w100"
      stripe
      @row-click="click"
      row-class-name="pointer"
    >
      <el-table-column label="Directory">
        <template slot-scope="props">
          <div class="capitalize">{{ props.row }}</div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  computed: {
    ...mapState('fileManager', ['directories', 'directory'])
  },

  watch: {
    directory: function() {
      this.readFile()
    }
  },

  methods: {
    ...mapActions('fileManager', ['readDirectory', 'readFile']),
    ...mapMutations('fileManager', ['setSelectedDirectory', 'setFiles']),

    click(row) {
      this.setSelectedDirectory(row)
    }
  },

  created() {
    this.readDirectory()
    this.readFile()
  }
}
</script>
